import { Controller } from '@hotwired/stimulus';

export default class ActionItemListController extends Controller {
  static targets = ['actionItem'];

  connect() {
    this.attachAjaxListeners();
  }

  attachAjaxListeners() {
    document.addEventListener(
      'actionItemCard.saveSuccess',
      this.onSaveSuccess.bind(this),
      false
    );
  }

  onSaveSuccess(event) {
    const payload = event.detail;
    this.getTargetById(payload.id).dataset.completed = payload.complete;
  }

  getTargetById(id) {
    return this.actionItemTargets.find((x) => x.dataset.id === id);
  }
}
